
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Ayurvedam Doctors",
      queryName: "Ayurvedam",
      teamName: "Ayurvedam team",
    };
  },
  components: { DoctorsList },
});
